/**
Copyright (C) 2018 Andras Sarvari <andras.sarvari@sarvaria.net>

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
*/

/* jshint browser: true, esversion: 6, node:true */
/* globals console */

import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Actionbar from '../Actionbar/Actionbar';
import Menucontainer from '../Menucontainer/Menucontainer';
import Login from '../Login/Login';
import Main from '../Main/Main';
import Menu from '../Menu/Menu';
import Spinner from '../Spinner/Spinner';
import $ from '../Util/Util';
import './App.css';

/**
 * Application entry point.
 */

export default class App extends Component {

    /** Orientation modes. */
    static get ORIENTATION() { return {
        PORTRAIT:   'portrait',
        LANDSCAPE:  'landscape'
    };}

    /** Screen size. */
    static get SCREENSIZE() { return {
        WIDTH:      1024,
        HEIGHT:     576
    };}

    /** Browser types. */
    static get BROWSER() { return {
        CHROME:     'Chrome',
        FIREFOX:    'Firefox',
        EDGE:       'Edge'
    };}

    /** Supported locales. */
    static get LOCALE() { return {
        DEFAULT:    'ro',
        HU:         'hu',
        EN:         'en',
        RO:         'ro'
    };}

    /** Default state. */
    state = {
        context: {
            version:        '0.0.38',
            environment:    this._getEnvironment(),
            locale:         {},
            user:           null
        },
        showmenu:           false,
        removebackdrop:     true,
        actionbartitle:     null,
        actionbarrighticon: null,
        back:               false
    }
    
    /**
     * Sets the environment attributes of the application.
     */
     
    _getEnvironment() {
    
        // Returns the environment
        
        let browser = this._browser();

        // Getting the screen size

        let screen = {
            width:          browser.mobile ? window.innerWidth : App.SCREENSIZE.WIDTH,
            height:         browser.mobile ? window.innerHeight : App.SCREENSIZE.HEIGHT
        };

        // Setting usefull screen height

        screen.usefullheight = screen.height - 56;

        // Setting the zoom level

        screen.zoom = browser.mobile ? 1 : 
        Math.min(
            (window.innerWidth - 16) / screen.width,
            (window.innerHeight - 16) / screen.height
        );

        return {
            screen:             screen,
            browser: {
                info:           browser,
                orientation:    window.screen.orientation ? 
                                (window.screen.orientation.angle % 180 === 0 ?
                                App.ORIENTATION.PORTRAIT : 
                                App.ORIENTATION.LANDSCAPE) : 
                                App.ORIENTATION.PORTRAIT,
                width:          window.innerWidth,
                height:         window.innerHeight
            }
        };     
    }

    /**
     * Gets the current browser type, version and that is a mobile/tablet device
     * or not. Can be 'Chrome', 'Firefox', 'IE' or 'Opera' and its version
     * number.
     *
     * @return  {Object}    browser     browser type, version and it is a mobile
     */
    
    _browser() {
    
        // Preparing
    
        let ua = window.navigator.userAgent;
        let tem;
        let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    
        // Detecting IE
    
        if (/trident/i.test(M[1])) {
            tem =  /\brv[ :]+(\d+)/g.exec(ua) || [];
            return { type: 'IE', version: tem[1] || '' };
        }
    
        // Detecting Chrome
    
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
    
            if (tem !== null) {
                if (tem.length >= 3 && tem[1] === 'Edge') {
                    return {
                        type:       tem[1],
                        version:    tem[2]
                    };
                } else {
                    return {
                        type:       'Opera',
                        version:    tem.slice(1).join(' ').replace('OPR', '')
                    };
                }
            }
        }
    
        // Detecting others
    
        M = M[2] ? [M[1], M[2]] : [
            window.navigator.appName, window.navigator.appVersion, '-?'
        ];
    
        if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
            M.splice(1, 1, tem[1]);
        }
    
        // Detecting mobiles and tablets
        
        let mobile = false;
        (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0,4)))mobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
    
        // Returns the browser type and its version
    
        return { type: M[0], version: M[1], mobile: mobile };
    }
  
    /**
     * Redraws the application.
     */

    _redraw = () => {

        // Reseting the environment

        let context = this.state.context;
        context.environment = this._getEnvironment();
        
        // Storing the context of the application

        this.setState({ context: context });
    }

    /**
     * Does any CTRL+[key] key pressed?
     * 
     * @param     {Object}     event     event object
     */
 
    _shortcutHandler = (event) => {

        // Does the control key pressed?

        if ((event.nativeEvent.ctrlKey || event.nativeEvent.metaKey)) {

            // Getting the pressed key

            let key = event.nativeEvent.keyCode ? event.nativeEvent.keyCode : event.nativeEvent.which;

            // Does the key the CTRL+M?

            if (key === 77) {
                this._toggleMenu();
                
            // Does the control key handler defined?

            } else if (key !== 17 && this.main.controlKeyHandler) {

                // Handling the control key

                if (this.main.controlKeyHandler(key)) {

                    // Preventing default functionality if the control key
                    // handled by the application.

                    event.nativeEvent.preventDefault();
                    event.nativeEvent.stopPropagation();
                }
            }
        }
    }

    /**
     * Gets the style of the main screen content.
     * 
     * @param   {Boolean}   mobile      is it a mobile platform or not
     * @return  {Object}    style       style of the main screen content
     */

    _getContentStyle = (mobile) => {

        // Preparing

        let style = {};

        // Determining the size of the main screen content

        if (mobile) {
            style.width = this.state.context.environment.browser.width + 'px';
            style.height = this.state.context.environment.browser.height + 'px';
            style.left = '50%';
            style.top = '50%';
        } else {
            style.width = this.state.context.environment.screen.width + 'px';
            style.height = this.state.context.environment.screen.height + 'px';

            // Setting the scale of the main screen content

            style.zoom = this.state.context.environment.screen.zoom; 

            // Scaling functionality is different in Firefox

            if (this.state.context.environment.browser.info.type === App.BROWSER.FIREFOX) {
                style.MozTransform = 'scale(' + this.state.context.environment.screen.zoom + ')';
                style.MozTransformOrigin = '0 0';
                style.left = parseInt((this.state.context.environment.browser.width - 
                             (this.state.context.environment.screen.zoom * this.state.context.environment.screen.width)) / 2, 10) + 'px';
                style.top = parseInt((this.state.context.environment.browser.height - 
                            (this.state.context.environment.screen.zoom * this.state.context.environment.screen.height)) / 2, 10) + 'px';
            } else {
                style.left = '50%';
                style.top = '50%';
            }
        }

        // Returns the style of the main screen content

        return style;
    }

    /**
     * Getting the style of the backdrop.
     * 
     * @return  {Object}    style       style of the backdrop
     */

    _getBackdropStyle = () => {

        // Getting the top coordinate of the backdrop

        let TOP = this.state.context.environment.screen.height - 
                  this.state.context.environment.screen.usefullheight - 3;

        // Returns the style of the backdrop

        return {
            width:      this.state.context.environment.screen.width + 'px',
            height:     this.state.context.environment.browser.info.mobile ? '100%' : 
                        ((this.state.context.environment.screen.height - TOP) + 'px'),
            top:        TOP + 'px',
            opacity:    this.state.showmenu ? 0.6 : 0,
            display:    this.state.removebackdrop ? 'none' : undefined
        };
    }
    
    /**
     * Toggles the menu.
     */

    _toggleMenu = () => {

        // Getting and showing the menu

        let menu = ReactDOM.findDOMNode(this.menu);
        menu.style.opacity = 1;

        // Does the menu opened?

        if (this.state.showmenu) {

            // Closing the menu and hiding the backdrop

            this.setState({ showmenu: false }, () => {
                setTimeout(() => {
                    menu.style.opacity = 0;
                    this.setState({ removebackdrop: true });
                }, 200);
            });
        } else {

            // Showing the menu and showing the backdrop

            this.setState({ removebackdrop: false }, () => {
                setTimeout(() => {
                    this.setState({ showmenu: true });
                }, 20);
            });
        }
    }
    
    /**
     * Closes the menu if it was opened.
     * 
     * @param     {Object}     event     event object
     */

    _closeMenu = (event) => {

        // Does the menu opened?

        if (this.state.showmenu) {

            // Closing the menu

            if (event) {
                event.preventDefault();
            }
            
            this._toggleMenu();
        }
    }

    /**
     * Sets the title on the actionbar.
     * 
     * @param   {String}    title   title on the actionbar
     */

    _setActionbarTitle = (title) => {
        this.setState({ actionbartitle: title });
    }

    /**
     * Sets the icon on the actionbar's right side.
     * 
     * @param   {String}    icon    icon on the actionbar's right side
     */

    _setActionbarRightIcon = (icon) => {
        this.setState({ actionbarrighticon: icon });
    }

    /** 
     * Event that fires when the user touches the right icon on the
     * actionbar.
     * 
     * @param     {Object}     event     event object
     */

    _onRightIconTouched = (event) => {

        // Stop propagation

        event.stopPropagation();
        
        // Delegating the touch event to the main component
        
        this.main.onRightIconTouched();
    }

    /** 
     * Event that fires when the user touches the back icon on the
     * actionbar.
     */
    
    _onBack = () => {
        this.main.onBack();
    }

    /**
     * Sets the back icon visibility on the actionbar.
     * 
     * @param   {Boolean}   back    back icon is visible or not
     */

    _onSetBack = (back) => {
        this.setState({ back: back });
    }

    /**
     * Event that fires when the user selects the settings icon.
     */

    _onSettings = () => {
        this.menucontainer.clearMenupointSelection();
        this.main.showScreen('settings');
    }

    /**
     * Event that fires when the user selects the business report icon.
     */

    _onBusinessReport = () => {
        this.menucontainer.clearMenupointSelection();
        this.main.showScreen('businessreport');
    }

    /** 
     * Event that fires when the user selects a menupoint.
     * 
     * @param   {String}    menupoint   selected menupoint
     */

    _onMenupointSelected = (menupoint) => {

        // Showing the screen for the menupoint

        this.main.showScreen(menupoint);

        // Closing the menu
        
        this._closeMenu();
    }

    /**
     * Loads the locale.
     */

    _loadLocale = () => {
        
        // Determining the used locale

        let locale = App.LOCALE[((window.location.search ? $.getURLParameters().locale : null) || 
            ((navigator.language || navigator.userLanguage) || '').substring(0, 2)).toUpperCase()] 
            || App.LOCALE.DEFAULT;

        // Creating new AJAX request

        let xhr = new XMLHttpRequest();

        // State listener

        xhr.onreadystatechange = (event) => {

            // AJAX request finished, response arrived

            if (xhr.readyState === 4) {

                // Was any error?

                if (xhr.status === 200) {

                    // Getting the response

                    let content = xhr.responseText;

                    // Trying to convert the response to JSON object

                    try {
                        content = JSON.parse(content);
                    } catch(error) {
                        // No handler
                    }

                    let context = this.state.context;
                    context.locale = content;
                    this.setState({ context: context });
                } else {
                    // No handler
                }
            }
        };

        // Preparing the request

        xhr.open('GET', `${window.location.origin}/locale/${locale}.json?${new Date().getTime()}`, true);
        xhr.setRequestHeader('Content-type', 'application/json; charset=utf-8');

        // Sending the AJAX request

        xhr.send();
    }

    /**
     * Event that fires when the user logged in successfully.
     * 
     * @param   {Object}    user    user information
     */

    login = (user) => {

        // Getting the current context and storing the user

        let context = this.state.context;
        context.user = user;

        // Updating the context

        this.setState({ context: context }, () => {

            // Selecting first menupoint
            
            this.menucontainer.selectFirstMenupoint();

            // Setting the login and the main screen visibilities

            setTimeout(() => {
                if (!user) {
                    this.loginScreenContainer.style.display = '';
                }

                this.loginScreenContainer.style.opacity = user ? 0 : 1;
                this.screenContainer.style.opacity = user ? 1 : 0;
                
                if (user) {
                    setTimeout(() => {
                        this.loginScreenContainer.style.display = 'none';
                    }, 200);
                }
            }, 200);
        });
    }

    /**
     * Event that fires when the user logged out successfully.
     */    

    logout = () => {

        // Closing the menu
                
        this._closeMenu();

        // Logging out

        this.loginScreen.logout().then(() => {
            this.login(null);
        }).catch((error) => {
            // No handler
        });
    }
    
    /** 
     * Event that fires when the component mounted.
     */

    componentDidMount() {

        // Loadig the locale

        this._loadLocale();

        // Orientation change listener
        
        window.addEventListener('orientationchange', this._redraw, false);

        // Browser resize listener
        
        window.addEventListener('resize', this._redraw, false);
    }

    /** 
     * Event that fires when the component will unmount.
     */

    componentWillUnmount() {

        // Removing listeners

        window.removeEventListener('orientationchange', this._redraw, false);
        window.removeEventListener('resize', this._redraw, false);
    }
    
    /**
     * Application renderer.
     */

    render() {
        return (
            this.state.context.locale.locale ?

            <div className="mainscreen" style={{ height: this.state.context.environment.browser.height + 'px' }} onClick={this._closeMenu} onKeyDown={this._shortcutHandler}>
                <div className="mainscreen-content horizontal vertical center center-justified" style={ this._getContentStyle(this.state.context.environment.browser.info.mobile) }>

                    {/* Login screen */}

                    <div ref={c => {this.loginScreenContainer = c;}} tabIndex="0" className="loginscreen" style={{ outline: 'none', width: this.state.context.environment.screen.width + 'px', height: this.state.context.environment.screen.height + 'px'}}>
                        <Login ref={c => {this.loginScreen = c;}} context={this.state.context} onLogin={this.login}/>
                    </div>

                    {/* Main screen */}

                    <div ref={c => {this.screenContainer = c;}} className="mainscreen-screencontainer" style={{display: this.state.context.user ? '' : 'none'}}>
                        <Actionbar context={this.state.context} appname={this.state.context.environment.browser.info.mobile ? this.state.actionbartitle : `${Main.appname()} - ${this.state.actionbartitle}`} menuvisible={this.state.showmenu} showBack={this.state.back} rightIcon={this.state.actionbarrighticon} onRightIconTouched={this._onRightIconTouched} onToggleMenu={this._toggleMenu} onBack={this._onBack} onSettings={this._onSettings} onBusinessReport={this._onBusinessReport} />
                        <Menu ref={c => {this.menu = c;}} context={this.state.context} visible={this.state.showmenu}>
                            <Menucontainer ref={c => {this.menucontainer = c;}} context={this.state.context} onLogout={this.logout} onMenupointSelected={this._onMenupointSelected} />
                        </Menu>
                        <div ref={c => {this.content = c;}} tabIndex="1" style={{ outline: 'none', height: this.state.context.environment.screen.usefullheight + 'px'}}>
                            <Main ref={c => {this.main = c;}} context={this.state.context} onLogout={this.logout} onSetActionbarTitle={this._setActionbarTitle} onSetActionbarRightIcon={this._setActionbarRightIcon} onSetBack={this._onSetBack} />
                        </div>
                    </div>

                    {/* Backdrop */}

                    <div className="mainscreen-backdrop" style={this._getBackdropStyle()}></div>

                    {/* Left nomansland */}

                    <div className="leftnomansland" style={{ right: this.state.context.environment.screen.width + 'px' }}></div>
                </div>

                {/* Bottom nomansland */}

                <div className="bottomnomansland" style={{ height: ((this.state.context.environment.browser.height - (this.state.context.environment.screen.height * this.state.context.environment.screen.zoom)) / 2) + 'px' }}></div>
            </div> : 
            
            /* Loader */

            <div className="horizontal vertical center center-justified" style={{ height: this.state.context.environment.browser.height + 'px' }}>
                <Spinner />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/App/App.js